export type Delegator = {
  get: (key: string) => string;
} | null;

export enum EnvironmentVariables {
  BASE_URL = 'BASE_URL',
  ENVIRONMENT = 'ENVIRONMENT',
  AUTH_URL = 'AUTH_URL',
  PLATFORM = 'PLATFORM',
}
